module.exports = __webpack_public_path__ + "img/形状 1140@2x.af00d493.png";